import moment from "moment";
import React, { useEffect, useState, useCallback } from "react";
import { logWebHook } from "../../../../../api";
import Plus from "../../../../assets/svg/icons/common/Plus";
import CheckGrayCircleIcon from "../../../../assets/svg/icons/common/check-gray-circle";
import CheckGreenCircleIcon from "../../../../assets/svg/icons/common/check-green-circle";
import CrossRedCircleIcon from "../../../../assets/svg/icons/common/cross-red-circle";
import Accordion from "../../../../components/Accordion";
import Spinner from "../../../../components/Loaders/Spinner";
import Button from "../../../../components/new-button";
import useCommonStore from "../../../../stores/common";
import useOrganizationStore from "../../../../stores/organization";
import AddEditWebhookModal from "./add-edit-webhook-modal";
import styles from "./styles.module.scss";
import ReactPaginate from "react-paginate";
import Pagination from "../../../../components/Pagination/Pagination";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";

// Not in v1
const STATUS_FILTERS = [
  { label: "All", value: "all" },
  { label: "200", value: "200" },
  { label: "204", value: "204" },
  { label: "404", value: "404" },
];

// const WEBHOOK_TYPES = [
//   { label: "All", value: "all" },
//   // { label: "Payment Cloud Status", value: "payment_cloud_status" },
//   { label: "Var Sheet", value: "var_sheet" },
//   { label: "Processor Status", value: "processor_status" },
//   { label: "Notes", value: "notes" },
//   { label: "Chargeback", value: "chargeback" },
//   { label: "Transaction", value: "transaction" },
// ];

const getIcon = (status) => {
  switch (status) {
    case "200":
      return <CheckGreenCircleIcon />;
    case "204":
      return <CheckGrayCircleIcon />;
    case "404":
      return <CrossRedCircleIcon />;
    default:
      return <CheckGreenCircleIcon />;
  }
};

const Webhook = () => {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const [addEditModalOpen, setAddEditModalOpen] = useState(false);
  const [webhooks, setWebhooks] = useState([]);
  const [webhooksLoading, setWebhooksLoading] = useState(false);
  const [expandedItems, setExpandedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  // Not in v1
  const [statusCode, setStatusCode] = useState("All");
  // const [activeTypeFilter, setActiveTypeFilter] = useState("all");
  const selectedOrganizationId = useOrganizationStore(
    (state) => state.selectedOrganizationId,
  );

  const handleItemToggle = (id) => {
    setExpandedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const onStatusCodeChange = (val) => {
    setStatusCode(val);
  };

const accordionItems =
  webhooks &&
  webhooks.map((item) => {
    let parsedResponse;

    try {
      parsedResponse = JSON.parse(item.response); // convert to object
    } catch (e) {
      parsedResponse = item.response; // fallback if not valid JSON
    }

    return {
      id: item.id,
      title: (
        <div className={styles.webhookHeader}>
          <div className={styles.idSection}>
            <span className={styles.id}># {item.id}</span>
            <span className={styles.status_code}>
              Status: {getIcon(item.status_code.toString())} {item.status_code}
            </span>
          </div>
          <span className={styles.timestamp}>
            {moment(item.created_at).format("MM/DD/YYYY hh:mm:ss A")}
          </span>
        </div>
      ),
      content: (
        <div className={styles.webhookContent}>
          <pre>{parsedResponse}</pre>
        </div>
      ),
    };
  });

  const fetchWebhooks = useCallback(
    async (page = 1) => {
      try {
        setWebhooksLoading(true);
        const response = await logWebHook({
          organizationId: selectedOrganizationId,
          page: page,
          status_code: statusCode
        });
        setWebhooks(response?.data?.data);
        setCurrentPage(response?.data?.current_page || 1);
        setTotalPages(response?.data?.last_page || 1);
        setTotalItems(response?.data?.total || 0);
        setWebhooksLoading(false);
      } catch (error) {
        console.error(error);
        setWebhooksLoading(false);
      }
    },
    [selectedOrganizationId, statusCode],
  );

  useEffect(() => {
    fetchWebhooks();
  }, [fetchWebhooks]);

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    fetchWebhooks(newPage);
  };

  if (webhooksLoading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "32px" }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <div
      className={`${styles.webhook} ${expandDetails ? styles.expanded : ""}`}
    >
      <div className={styles.header}>
        <div className={styles.filters}>
          {/* Hide hook status filtering for now since it's not in v1 */}
          <SlidingTab
            activeBackground="white"
            options={STATUS_FILTERS.map((filter) => filter.label)}
            onChange={onStatusCodeChange}
            noShortCodes={true}
            selectedTab={statusCode}
            fullWidth={true}
          />
        </div>
        <div className={styles.filterActionArea}>
          {/* Hide dropdown filtering for now since it's not in v1 */}
          {/* <DropDown
            options={WEBHOOK_TYPES.map((type) => ({
              text: type.label,
              value: type.value,
              onClick: () => setActiveTypeFilter(type.value),
            }))}
            onClick={(option) => setActiveFilter(option.value)}
            bgColor="#EDEDF4"
            showArrow
            smallFont
          >
            <FilterIcon />{" "}
            {
              WEBHOOK_TYPES.find((type) => type.value === activeTypeFilter)
                ?.label
            }
          </DropDown> */}
          <Button
            variant="primary"
            icon={<Plus />}
            onClick={() => setAddEditModalOpen(true)}
          >
            {expandDetails && 'Add/Edit'}
          </Button>
        </div>
      </div>
      <div className={styles.webhookList}>
        {webhooks && webhooks.length > 0 ? (
          <>
            <Accordion
              items={accordionItems}
              expandedItems={expandedItems}
              onItemToggle={handleItemToggle}
              className={styles.webhookAccordion}
            />

            <Pagination
              currentPage={currentPage - 1}
              pageCount={totalPages}
              pageRangeDisplayed={5}
              marginPagesDisplayed={2}
              onPageChange={handlePageChange}
              containerClassName={styles.pagination}
            />
          </>
        ) : (
          <div className={styles.noData}>
            <p>No webhook logs to display</p>
          </div>
        )}
      </div>

      <AddEditWebhookModal
        open={addEditModalOpen}
        onClose={() => setAddEditModalOpen(false)}
      />
    </div>
  );
};

export default Webhook;
